export default "__VITE_ASSET__CqBA$mnC__"